import  React, {use, useEffect, useState} from 'react';
import './styles/MensajeError.css';
import { hover } from '@testing-library/user-event/dist/hover';
import AskImg from './../assets/img/AskImg.png';


//RepPrA
const MensajeQuestion = ({ mensaje, show, opcion1, onClose }) => {


    const handleCerrarMsgAlerta = () => {
        if (onClose) { 
            onClose(); 
        }
    };

    const handleOpcion1 = () =>{
        if(opcion1){
            opcion1();
        }
    }

    if (!show) {
        return null;
    }

    return (
        <div className='mEMain'>
            <img src={AskImg} alt="Error" /> 
            <p>{mensaje}</p>
            <button className='buttonStandartGreen' onClick={handleOpcion1}>Aceptar</button>
            <button className='buttonStandartRed' onClick={handleCerrarMsgAlerta}>Cancelar</button>
        </div>
    );
};


export default MensajeQuestion;